import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {Notification} from "./Notification";

export class Notifications {
  constructor() {
    this.$container = $(".notifications-center .notifications");
    this.$scenarioContainer = $(".notifications-center .current-scenario");
    this.$items = this.$container.find(".notification");
    this.items = [];
    this.scenarioItem = null;

    this.duration = 0.60;
    this.currentTimeline = null;
    this.isStacked = false;
    this.isAnimating = false;

    this.init();
  }

  init() {
    $(document).off("click.notificationToggle")
      .on("click.notificationToggle", ".notifications-center .trigger-arrow", (e) => {
        e.stopPropagation();
        const $notif = $(e.currentTarget).closest(".notification");
        const $parent = $notif.parent();
        if ($notif.hasClass("stack-item") && $parent.hasClass("stacked")) return;

        const instance = this.items.find(n => n.$el && n.$el[0] === $notif[0])
          || (this.scenarioItem && this.scenarioItem.$el && this.scenarioItem.$el[0] === $notif[0] ? this.scenarioItem : null);
        if (!instance) return;

        app.audio.play("audio/ButtonOnClick_260423.wav", 1, true);
        instance.setShown(!$notif.hasClass("shown"));
      });
  }

  /**
   * @param {boolean|null} forceState - true to stack, false to expand, null to toggle
   */
  stackToggle(forceState = null, {force = false} = {}) {
    if (this.isAnimating) return;
    const shouldStack = (forceState !== null) ? forceState : !this.isStacked;
    if (!force && shouldStack === this.isStacked) return;

    this.$items = this.$container.find(".notification");
    if (this.$items.length <= 2) return;

    this.isAnimating = true;
    this.isStacked = shouldStack;
    this.$container.toggleClass("stacked", shouldStack);

    // Kill previous timeline
    if (this.currentTimeline) this.currentTimeline.kill();
    this.currentTimeline = gsap.timeline({
      defaults: {duration: this.duration, ease: "expo.inOut"},
      onComplete: () => {
        this.isAnimating = false;
        // On expand, clear all inline transforms from items
        if (!this.isStacked) {
          gsap.set(this.$items, {clearProps: "all"});
        }
      }
    });

    // Animate items — first 2 stay normal; from index 2, stack with k = i-2.
    // k=0 sits flush, k=1 and k=2 peek out, k>=3 is hidden entirely.
    this.$items.each((i, el) => {
      const k = i - 2;

      if (k >= 3) {
        this.currentTimeline.set(el, {
          display: this.isStacked ? "none" : "",
          marginTop: 0,
          scale: 1,
          opacity: 1,
        }, "<");
        return;
      }

      const marginTopFor = (kk) => {
        if (kk <= 0) return 0;
        if (kk === 1) return -68;
        if (kk === 2) return -64;
        return 0;
      };
      const itemScale = k <= 0 ? 1 : k === 1 ? 0.96 : 0.92;
      const itemOpacity = k <= 0 ? 1 : k === 1 ? 0.5 : 0.3;

      this.currentTimeline.to(el, {
        marginTop: () => this.isStacked ? marginTopFor(k) : 0,
        scale: this.isStacked ? itemScale : 1,
        opacity: this.isStacked ? itemOpacity : 1,
        display: "",
      }, "<"); // "<" keeps items animating in parallel with the container
    });
  }

  async addScenarioNotification(data) {
    const notification = new Notification(this.$scenarioContainer, data);
    await notification.render();
    notification.setShown(true); // show by default
    this.scenarioItem = notification;
    return notification;
  }

  async addNotification(data) {
    const notification = new Notification(this.$container, data);
    await notification.render({prepend: true});
    this.items.unshift(notification);
    this.$items = this.$container.find(".notification");

    // Newest on top, toggled on. Existing items keep their current shown state
    // so that anything the user already closed stays closed — except items that
    // are pushed into the stack, which must close.
    this.items.forEach((n, i) => {
      const isStackItem = i >= 2;
      if (n === notification) n.setShown(!isStackItem);
      else if (isStackItem) n.setShown(false, {instant: true});
      n.$el.toggleClass("stack-item", isStackItem);
    });

    // Slide newest in from above
    gsap.fromTo(
      notification.$el,
      {opacity: 0, y: -16},
      {opacity: 1, y: 0, duration: 0.4, ease: "power2.out"}
    );

    if (this.$items.length > 2) {
      // Re-run layout to reposition the stack after prepend
      this.stackToggle(true, {force: true});
    }

    return notification;
  }

  clear() {
    this.items.forEach((n) => n.destroy());
    this.items = [];
    if (this.scenarioItem) this.scenarioItem.destroy();
    this.scenarioItem = null;
    this.$scenarioContainer.empty();
    this.$items = this.$container.find(".notification");
  }

  reset() {
    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }

    this.clear();

    this.$container.removeClass("stacked");
    this.isStacked = false;
    this.isAnimating = false;
  }
}
